import apiClient, { withAuth } from './api';

export const payoutService = {
  // Account management
  getAccount: (token) => {
    return apiClient.get('/api/payout/account', withAuth(token));
  },
  
  createAccount: (data, token) => {
    return apiClient.post('/api/payout/create-account', data, withAuth(token));
  },
  
  createDashboardLink: (token) => {
    return apiClient.get('/api/payout/dashboard', withAuth(token));
  },
  
  // Payout history
  getPayoutHistory: (token) => {
    return apiClient.get('/api/payout/history', withAuth(token));
  },
  
  getNextPayout: (token) => {
    return apiClient.get('/api/payout/next', withAuth(token));
  },
  
  // Bank accounts
  getBankAccounts: (token) => {
    return apiClient.get('/api/payout/bank-accounts', withAuth(token));
  },
  
  addBankAccount: (data, token) => {
    return apiClient.post('/api/payout/bank-accounts', data, withAuth(token));
  },
  
  setDefaultBankAccount: (data, token) => {
    return apiClient.post('/api/payout/bank-accounts/default', data, withAuth(token));
  }
};

export default payoutService;